export default async function copyTextToClipboard(text: string) {
  if ('clipboard' in navigator) {
    const clipboard = navigator.clipboard as Clipboard;
    return clipboard.writeText(text);
  }
  return document.execCommand('copy', true, text);
}
